import React from "react";
import { SharedLinkCard } from "@/features/previews/shared/components";

interface LinkItemProps {
  text: string;
  url: string;
  imageUrl?: string;
  buttonColor?: string;
}

export function LinkItem({ text, url, imageUrl, buttonColor }: LinkItemProps) {
  return (
    <div className="list-links-template__link-item">
      <SharedLinkCard
        text={text}
        url={url}
        imageUrl={imageUrl}
        buttonColor={buttonColor}
      />
    </div>
  );
}
